var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from "react";
import * as Styled from "./AnalyticsStyles";
import ListHeader from "@/components/HubList/ListHeader";
import { observer } from "mobx-react";
import useAdminStore from "@/services/store/useAdminStore";
import { Mixpanel } from "@/utilities/mixpanel/Mixpanel";
import api from "@/api/admin";
import { useAcl } from "@/api/auth/useAcl";
import translate from "@/utilities/i18n/getTranslate";
import { k } from "@/utilities/i18n";
import useErrorHandler from "@/utilities/hooks/useErrorHandler";
import { useDarkMode } from "@/compass/utils/useDarkMode";
var Analytics = function () {
    var adminStore = useAdminStore().adminStore;
    var handleError = useErrorHandler();
    var partnerId = useAcl().partnerId;
    var mode = useDarkMode().mode;
    var _a = __read(React.useState(""), 2), omniUrl = _a[0], setOmniUrl = _a[1];
    var _b = __read(React.useState(true), 2), loading = _b[0], setLoading = _b[1];
    React.useEffect(function () {
        Mixpanel === null || Mixpanel === void 0 ? void 0 : Mixpanel.track({
            name: "Opened partner dashboard",
            props: { type: "event", payload: adminStore.currentUser },
        });
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, omniSession()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        fetchData();
    }, [partnerId]);
    var omniSession = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    if (!partnerId)
                        return [2 /*return*/];
                    return [4 /*yield*/, api.omni.omniSession({
                            partnerId: partnerId,
                            prefersDark: mode === "dark" ? "true" : "false",
                        })];
                case 1:
                    response = _a.sent();
                    setOmniUrl(response.ssoSessionUrl);
                    setLoading(false);
                    Mixpanel === null || Mixpanel === void 0 ? void 0 : Mixpanel.track({
                        name: "Partner dashboard loaded",
                        props: { type: "event", payload: adminStore.currentUser },
                    });
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    setLoading(false);
                    handleError(err_1, { message: translate(k.ERR_omniSessionError) }, "Error while getting omni session url");
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(Styled.Analytics, null,
        React.createElement(ListHeader, { header: {
                prefix: "Dashboard",
            }, enableVariableSize: true }),
        React.createElement(Styled.EmptyStateContainer, null,
            loading && (React.createElement(Styled.LoadingOverlay, null, translate(k.DASH_fetchingData))),
            !loading && omniUrl && (React.createElement("iframe", { src: omniUrl, width: "100%", height: "100%", frameBorder: "0", style: { display: "block" } })))));
};
export default observer(Analytics);
//# sourceMappingURL=data:application/json;base64,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